import { zodSchemes } from '@approvalmax/utils';
import { standaloneConstants } from 'modules/common/constants';
import { z } from 'zod';

export const schema = z.object({
    name: zodSchemes.required.textField.string().max(standaloneConstants.REQUEST_NAME_MAX_LENGTH),
    amount: zodSchemes.required.numberField
        .number()
        .min(standaloneConstants.TOTAL_MIN_AMOUNT)
        .max(standaloneConstants.TOTAL_MAX_AMOUNT),
    currencyId: zodSchemes.required.select.string(),
    date: z.string().nullable(),
});
